import cn from 'classnames';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';

import calendarIcon from 'assets/images/properties/calendar-event.svg';
import mapPointIcon from 'assets/images/properties/map-point.svg';
import { ReturnComponentType } from 'common';
import { CommonDataCard } from 'components';
import { DateFormat, Paths } from 'enums';
import { FeedsType } from 'state/reducers/properties/types';

import './FeedHistory.scss';

type FeedHistoryType = {
  feed: FeedsType;
  className?: string;
};

export const FeedHistory = ({
  feed,
  className,
}: FeedHistoryType): ReturnComponentType => {
  const navigate = useNavigate();

  const onInspectionClick = () => {
    if (feed?.inspectionId) {
      navigate(`${Paths.INSPECTIONS}/${feed?.inspectionId}`);
    }
  };

  return (
    <CommonDataCard
      className={cn('FeedHistory', !!feed?.inspectionId && 'FeedPointer', className)}
      onClick={onInspectionClick}
    >
      <>
        <section className="FeedHistory_Title">
          <span className="FeedHistory_Title_Dot" />
          {feed.name ?? '-'}
          <span className={`FeedHistory_Title_Label_${feed.status}`}>
            {feed.status ?? '-'}
          </span>
        </section>

        <section className="FeedHistory_Body">
          <img src={calendarIcon} alt="calendar-icon" className="FeedHistory_Body_Icon" />
          <div className="FeedHistory_Body_Date">
            {dayjs(feed?.createdAt).format(DateFormat.GENERAL)}
          </div>

          <div className="FeedHistory_Body_Name">
            <img
              src={mapPointIcon}
              alt="map-point-icon"
              className="FeedHistory_Body_Name_Icon"
            />
            {feed?.address ?? '-'}
          </div>
        </section>
      </>
    </CommonDataCard>
  );
};
